import UmlShape from './UmlShape';

// Activation/execution bar \u2014 shows a participant is "active" (processing)
// for the row-span between when it FIRST receives a call and its LAST
// message (in or out), see CsSeqCanvasLayoutBuilder.computeActivationRanges.
// Same live-x-tracking as UmlSeqLifelineShape (participantId) \u2014 only the
// vertical span is fixed at generation time. `name` is display-only (status
// bar/world-map label). startRowIndex/endRowIndex are this activation's own
// call/return positions in CsSeqShapeFactory's event order \u2014 used by
// CsSeqDiaRelationHandler's nested-group-move to work out which OTHER
// messages/activations sit temporally inside this one and must shift along
// with it when this bar is dragged.
class UmlSeqActivationShape extends UmlShape {
  constructor(id, x, y, w, h, participantId, participantName, startRowIndex = 0, endRowIndex = 0) {
    super(id, x, y, w, h);
    this.participantId = participantId;
    this.name = participantName ? (participantName + ' activation') : null;
    this.startRowIndex = startRowIndex;
    this.endRowIndex = endRowIndex;
    this.kind = 'seq-activation'; // discriminant voor UmlShapeSerializer.fromPlainShape
  }
}

export default UmlSeqActivationShape;
